(() => {
  const config = document.querySelector('[data-lovie-gallery-config]');
  if (!config) return;
  let settings;
  try { settings = JSON.parse(config.textContent); } catch { return; }
  const text = (key, values = {}) => Object.entries(values).reduce((s, [k, v]) => s.replaceAll(`{{ ${k} }}`, String(v)).replaceAll(`__${k}__`, String(v)), settings.text[key] || key);
  const norm = value => String(value || '').normalize('NFKC').toLowerCase().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim();
  const searchNorm = value => norm(value).replace(/\b(\w{3,}?)s\b/g, '$1');
  const read = key => { try { return JSON.parse(sessionStorage.getItem(`lovie-gallery-v2:${key}`)); } catch { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(`lovie-gallery-v2:${key}`, JSON.stringify(value)); } catch {} };
  const params = new URLSearchParams(location.search);
  const preview = params.get('preview_theme_id');
  const withPreview = url => { if (preview) url.searchParams.set('preview_theme_id', preview); return url; };
  const filename = value => {
    try { return decodeURIComponent(new URL(value, location.origin).pathname.split('/').pop()).replace(/_\d+x\d*(?=\.[^.]+$)/, ''); } catch { return ''; }
  };
  const emit = (name, detail = {}) => {
    document.dispatchEvent(new CustomEvent(`lovie:mascot:${name}`, {detail}));
    if (settings.preview) return;
    try {
      const privacy = window.Shopify?.customerPrivacy;
      if (!privacy?.analyticsProcessingAllowed()) return;
      Promise.resolve(window.Shopify?.analytics?.publish(`lovie_mascot_${name}`, detail)).catch(() => {});
    } catch {}
  };
  const safeQuery = value => /^[\p{L}\p{N} '\-]{1,64}$/u.test(value) ? value : '';
  const galleryURL = (key, query = '', restore = false) => {
    const url = new URL(key ? `/pages/gallery-${key}` : '/pages/mascot-design-gallery', location.origin);
    if (query) url.searchParams.set('q', query);
    if (restore) url.searchParams.set('return', '1');
    return withPreview(url).href;
  };
  const bindSearch = (root, update) => {
    const input = root.querySelector('[data-gallery-search]');
    const clear = root.querySelector('[data-gallery-clear]');
    const query = params.has('q') ? params.get('q') : read('query') || '';
    input.value = query;
    let timer;
    const run = track => {
      clear.hidden = !input.value;
      write('query', input.value.trim());
      const url = new URL(location.href);
      if (input.value.trim()) url.searchParams.set('q', input.value.trim()); else url.searchParams.delete('q');
      url.searchParams.delete('return');
      history.replaceState(history.state, '', url);
      update(input.value.trim(), track);
    };
    input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(() => run(true), 180); });
    clear.addEventListener('click', () => { input.value = ''; clearTimeout(timer); run(true); input.focus(); });
    run(false);
    return input;
  };
  const makeLink = (href, label, className = '') => {
    const link = document.createElement('a'); link.href = href; link.textContent = label; link.className = className; return link;
  };
  const restoreScroll = root => {
    const navigation = performance.getEntriesByType('navigation')[0];
    if (params.get('return') !== '1' && navigation?.type !== 'back_forward') return;
    const key = `${location.pathname}:${root.querySelector('[data-gallery-search]')?.value || ''}`;
    const stored = read(`position:${key}`);
    if (stored) requestAnimationFrame(() => requestAnimationFrame(() => scrollTo({top: stored.y, behavior: 'instant'})));
  };
  const saveScroll = root => {
    const query = root.querySelector('[data-gallery-search]')?.value.trim() || '';
    write(`position:${location.pathname}:${query}`, {y: scrollY});
  };
  const loadIndex = root => {
    let pending;
    return () => {
      if (!pending) pending = fetch(root.dataset.indexUrl).then(r => { if (!r.ok) throw new Error('index'); return r.json(); }).catch(() => ({}));
      return pending;
    };
  };
  document.querySelectorAll('[data-lovie-chooser]').forEach(root => {
    const mo = JSON.parse(root.querySelector('[data-lovie-mo]').textContent);
    const list = root.querySelector('[data-collection-list]');
    const links = [...list.querySelectorAll('a')];
    const active = new Set(links.map(link => new URL(link.href).pathname.split('/gallery-')[1]));
    const labels = {...settings.labels, ...mo.labels};
    const results = root.querySelector('[data-search-results]');
    const status = root.querySelector('[data-search-status]');
    const getIndex = loadIndex(root);
    let request = 0;
    const update = async (query, track) => {
      const serial = ++request;
      links.forEach(link => { const key = new URL(link.href).pathname.split('/gallery-')[1]; link.href = galleryURL(key, query); });
      results.replaceChildren();
      if (query.length < 2) { results.hidden = true; status.hidden = true; list.hidden = false; return; }
      status.textContent = text('searching'); status.hidden = false;
      const data = {...await getIndex()};
      if (serial !== request) return;
      for (const [name, key] of mo.pairs || []) data[name] = [...new Set([...(data[name] || []), key])];
      const hits = Object.entries(data).filter(([name, keys]) => searchNorm(name).includes(searchNorm(query)) && keys.some(key => active.has(key))).slice(0, 60);
      list.hidden = true;
      hits.forEach(([name, keys]) => {
        const row = document.createElement('li');
        const title = document.createElement('strong'); title.textContent = name;
        const styles = document.createElement('div'); styles.className = 'lovie-results__styles';
        [...new Set(keys)].filter(key => active.has(key)).forEach(key => styles.append(makeLink(galleryURL(key, query), labels[key] || key)));
        row.append(title, styles); results.append(row);
      });
      results.hidden = !hits.length;
      status.textContent = hits.length ? text('search_matches', {count: hits.length, query}) : text('no_match', {query});
      if (!hits.length) status.append(' ', makeLink('/pages/mascot-request-hub', text('request')));
      if (track) emit('search', {query: safeQuery(query), result_count: hits.length, collection_key: 'all'});
    };
    bindSearch(root, update);
    root.addEventListener('click', event => { if (event.target.closest('a')) saveScroll(root); });
    window.addEventListener('pagehide', () => saveScroll(root));
    restoreScroll(root);
    emit('gallery_viewed', {collection_key: 'all'});
  });
  document.querySelectorAll('[data-lovie-collection]').forEach(root => {
    const key = root.dataset.collectionKey;
    const mo = JSON.parse(root.querySelector('[data-lovie-mo]').textContent);
    const labels = {...settings.labels, ...mo.labels};
    const route = mo.routes[key] ? `/products/${mo.routes[key]}` : settings.routes[key];
    const cards = [...root.querySelectorAll('[data-gallery-card]')].filter(card => {
      if (card.querySelector('.lovie-gallery__badge, a[href*="/pages/retired-design-request"]') && !route) { card.hidden = true; return false; }
      return true;
    });
    const names = new Map();
    const count = root.querySelector('[data-gallery-count]');
    const empty = root.querySelector('[data-gallery-empty]');
    const elsewhere = root.querySelector('[data-gallery-elsewhere]');
    const getIndex = loadIndex(root);
    let sequence = 0;
    const linksForCards = query => {
      cards.forEach(card => {
        const link = card.querySelector('a');
        const small = card.querySelector('small');
        const image = card.querySelector('img');
        if (!link || !small) return;
        const url = withPreview(new URL(route || link.href, location.origin));
        url.searchParams.set('mascot', small.textContent.trim());
        if (image) url.searchParams.set('mascot_image', filename(image.src));
        url.searchParams.set('mascot_collection', key);
        url.searchParams.set('mascot_style', labels[key] || key);
        url.searchParams.set('gallery_q', query);
        link.href = url.href;
        link.setAttribute('aria-label', text('choose_design', {name: small.textContent.trim(), style: labels[key] || key}));
        const action = card.querySelector('b'); if (action) action.textContent = text('choose_size');
      });
    };
    cards.forEach(card => {
      const small = card.querySelector('small');
      names.set(card, searchNorm(small?.textContent || card.dataset.search || ''));
      const version = small?.textContent.trim().match(/\s(\d+)$/);
      if (version) {
        const badge = document.createElement('span'); badge.className = 'lovie-gallery__version'; badge.textContent = text('version', {number: version[1]}); card.append(badge);
      }
    });
    const update = async (query, track) => {
      const current = ++sequence;
      let visible = 0;
      cards.forEach(card => { const match = !query || names.get(card).includes(searchNorm(query)); card.hidden = !match; if (match) visible++; });
      count.textContent = query ? text('design_matches', {count: visible, query}) : text('design_count', {count: visible});
      empty.hidden = visible > 0;
      linksForCards(query);
      root.querySelector('.lovie-gallery__back').href = galleryURL('', query, true);
      elsewhere.replaceChildren(); elsewhere.hidden = true;
      if (track) emit('search', {query: safeQuery(query), result_count: visible, collection_key: key});
      if (query.length < 2) return;
      const index = await getIndex();
      if (current !== sequence) return;
      const others = new Set();
      Object.entries(index).forEach(([name, keys]) => { if (searchNorm(name).includes(searchNorm(query))) keys.forEach(k => { if (k !== key) others.add(k); }); });
      for (const [name, k] of mo.pairs || []) if (k !== key && searchNorm(name).includes(searchNorm(query))) others.add(k);
      if (!others.size) return;
      const lead = document.createElement('span'); lead.textContent = text(visible ? 'also_available' : 'other_styles'); elsewhere.append(lead);
      const priority = ['retro-pop', 'starstruck', 'whimsy', 'grunge-varsity', 'pink-out-mascots', 'prism-script', 'bubble-stars'];
      const rank = k => priority.includes(k) ? priority.indexOf(k) : 100;
      [...others].sort((a, b) => rank(a) - rank(b) || (labels[a] || a).localeCompare(labels[b] || b)).slice(0, 6).forEach(k => elsewhere.append(makeLink(galleryURL(k, query), labels[k] || k)));
      if (others.size > 6) elsewhere.append(makeLink(galleryURL('', query), text('browse_all')));
      elsewhere.hidden = false;
    };
    bindSearch(root, update);
    root.addEventListener('click', event => {
      const card = event.target.closest('[data-gallery-card]');
      if (event.target.closest('a')) saveScroll(root);
      if (card) emit('design_clicked', {collection_key: key, mascot: card.querySelector('small')?.textContent.trim(), product_path: new URL(card.querySelector('a').href).pathname});
    });
    window.addEventListener('pagehide', () => saveScroll(root));
    restoreScroll(root);
    emit('gallery_viewed', {collection_key: key});
  });
  let finder = document.querySelector('[data-lovie-mascot-finder]');
  const fallbackCollection = params.get('mascot_collection') || Object.keys(settings.routes).find(key => settings.routes[key] === location.pathname);
  if (!finder && location.pathname.startsWith('/products/')) {
    const app = document.querySelector('.gpo-product-variants')?.closest('.shopify-app-block') || document.querySelector('form[action*="/cart/add"]')?.parentElement;
    if (app) {
      finder = document.createElement('div'); finder.className = 'lovie-mf'; finder.hidden = true; finder.dataset.lovieMascotFinder = '';
      finder.dataset.collectionKey = fallbackCollection || ''; finder.dataset.collectionLabel = params.get('mascot_style') || settings.labels[fallbackCollection] || '';
      const back = makeLink(galleryURL(fallbackCollection), text('back_results'), 'lovie-mf__back'); back.dataset.lmfBack = '';
      const label = document.createElement('label'); label.className = 'lovie-mf__label'; label.htmlFor = 'LovieFallbackMascotSearch'; label.textContent = text('finder_label');
      const input = document.createElement('input'); input.type = 'search'; input.id = label.htmlFor; input.className = 'lovie-mf__input'; input.placeholder = text('finder_placeholder'); input.autocomplete = 'off'; input.dataset.lmfInput = '';
      const results = document.createElement('ul'); results.className = 'lovie-mf__results'; results.dataset.lmfResults = ''; results.hidden = true;
      const note = document.createElement('p'); note.className = 'lovie-mf__note'; note.dataset.lmfNote = ''; note.setAttribute('role', 'status'); note.hidden = true;
      const all = makeLink(galleryURL(fallbackCollection), text('browse_all'), 'lovie-mf__all'); all.dataset.lmfAll = '';
      const size = document.createElement('p'); size.className = 'lovie-mf__size-note'; size.textContent = text('size_note');
      finder.append(back, label, input, results, note, all, size); app.before(finder);
    }
  }
  if (!finder) return;
  finder.hidden = !(params.get('mascot') && params.get('mascot_collection') && params.get('mascot_collection') === finder.dataset.collectionKey);
  const input = finder.querySelector('[data-lmf-input]');
  const list = finder.querySelector('[data-lmf-results]');
  const note = finder.querySelector('[data-lmf-note]');
  let items;
  try { items = JSON.parse(finder.querySelector('[data-lmf-data]')?.textContent || '[]').map(([name, image]) => ({name, image})); } catch { return; }
  const collection = finder.dataset.collectionKey;
  const style = finder.dataset.collectionLabel || '';
  const back = finder.querySelector('[data-lmf-back]');
  const query = params.get('gallery_q') ?? read('query') ?? '';
  if (back) back.href = galleryURL(collection, query, true);
  const all = finder.querySelector('[data-lmf-all]'); if (all) all.href = galleryURL(collection, query);
  const main = document.getElementById('MainContent');
  let pending = null;
  let pendingTimer;
  let rendering = false;
  let syncedValue = '';
  let imageURL = '';
  let activeGroup;
  const selectedImages = new Map();
  const groups = () => [...main.querySelectorAll('.gpo-element')].filter(group => group.classList.contains('lovie-mascot-picker') || /mascot|initial|design/i.test(group.querySelector('.label-content')?.textContent || '') || group.querySelector('[data-field-name="Mascot"]') || group.querySelector('input[type="radio"][data-url-img], input[type="radio"][data-image], select option[data-url-img], select option[data-image]'));
  const options = () => groups().flatMap(group => [...group.querySelectorAll('input[type="radio"], select option')]);
  const optionImage = option => {
    const explicit = option.getAttribute('data-url-img') || option.getAttribute('data-image');
    if (explicit) return explicit;
    const matching = items.filter(item => norm(item.name) === norm(option.value));
    return selectedImages.get(option.value) || (matching.length === 1 ? matching[0].image : '');
  };
  const match = (name, image) => {
    const candidates = options();
    if (image) {
      const hits = candidates.filter(option => filename(optionImage(option)) === filename(image));
      if (hits.length === 1) return hits[0];
      if (hits.length > 1) return null;
    }
    const target = norm(name);
    const exact = candidates.filter(option => norm(option.value) === target || norm(option.textContent) === target);
    if (exact.length) return exact.length === 1 ? exact[0] : null;
    const compact = candidates.filter(option => norm(option.value).replaceAll(' ', '') === target.replaceAll(' ', ''));
    if (compact.length) return compact.length === 1 ? compact[0] : null;
    const suffix = candidates.filter(option => norm(option.value).endsWith(` ${target}`));
    return suffix.length === 1 ? suffix[0] : null;
  };
  const selected = () => {
    for (const group of groups()) {
      const option = group.querySelector('input[type="radio"]:checked') || group.querySelector('select option:checked');
      if (option?.value && option.value !== '-- Please select --') return option;
    }
    return null;
  };
  const confirmed = option => {
    const group = option.closest('.gpo-element');
    if (option.tagName === 'OPTION') return option.selected;
    return option.checked && norm(group.querySelector('.dropdown-button__value')?.textContent) === norm(option.value);
  };
  const previewFigure = () => {
    const media = main.querySelector('product-images[data-modal="false"]') || main.querySelector('product-images');
    if (!media) return null;
    let figure = media.querySelector('[data-lovie-selected-preview]');
    if (!figure) {
      figure = document.createElement('figure'); figure.className = 'lovie-selected-preview'; figure.dataset.lovieSelectedPreview = '';
      figure.hidden = true;
      const link = document.createElement('a'); link.target = '_blank'; link.rel = 'noopener';
      const image = document.createElement('img'); image.width = 1000; image.height = 1000; image.decoding = 'async';
      link.append(image);
      const caption = document.createElement('figcaption');
      figure.append(link, caption); media.prepend(figure);
    }
    return figure;
  };
  const resetPreview = () => {
    main.querySelectorAll('.lovie-has-selected-preview').forEach(media => media.classList.remove('lovie-has-selected-preview'));
    const figure = main.querySelector('[data-lovie-selected-preview]'); if (figure) figure.hidden = true;
    main.classList.remove('lovie-has-mascot-preview');
    imageURL = '';
  };
  const showPreview = option => {
    const raw = optionImage(option);
    if (!raw) { resetPreview(); return; }
    let url;
    try { url = new URL(raw, location.origin); } catch { resetPreview(); return; }
    if (!['https:', 'http:'].includes(url.protocol)) { resetPreview(); return; }
    url.searchParams.delete('width'); url.searchParams.delete('height'); url.searchParams.set('width', '1200');
    const figure = previewFigure(); if (!figure) return;
    if (imageURL === url.href && figure.querySelector('figcaption').textContent === text('selected_design', {name: option.value})) return;
    const link = figure.querySelector('a'); const image = figure.querySelector('img');
    image.alt = text('selected_design', {name: option.value});
    link.setAttribute('aria-label', text('enlarge', {name: option.value})); link.href = raw;
    figure.querySelector('figcaption').textContent = text('selected_design', {name: option.value});
    imageURL = url.href;
    const captured = imageURL;
    image.onload = () => {
      if (imageURL !== captured) return;
      figure.hidden = false; figure.parentElement.classList.add('lovie-has-selected-preview'); main.classList.add('lovie-has-mascot-preview');
    };
    image.onerror = () => { if (imageURL === captured) resetPreview(); };
    image.src = imageURL;
    if (image.complete && image.naturalWidth) image.onload();
  };
  const sync = () => {
    if (!items.length && options().length) {
      items = options().map(option => ({name: option.value, image: optionImage(option)}));
      if (all) all.textContent = text('all_designs', {count: items.length});
    }
    const option = selected();
    if (!option || !confirmed(option)) return;
    activeGroup = option.closest('.gpo-element');
    activeGroup.classList.add('lovie-mascot-picker');
    if (syncedValue !== option.value) {
      syncedValue = option.value;
      input.value = option.value; list.hidden = true;
      note.textContent = text('selected', {name: option.value}); note.hidden = false;
      emit('selected', {collection_key: collection, mascot: option.value});
    }
    showPreview(option);
  };
  const stopPending = () => { pending = null; clearTimeout(pendingTimer); };
  const applyPending = () => {
    if (!pending || rendering) return;
    const option = match(pending.name, pending.image);
    if (!option) return;
    if (!option.getAttribute('data-url-img') && pending.image) {
      const supplied = pending.image.includes('/') ? pending.image : `/cdn/shop/files/${encodeURIComponent(pending.image)}`;
      selectedImages.set(option.value, supplied);
    }
    rendering = true;
    if (!confirmed(option)) {
      if (option.tagName === 'OPTION') { option.selected = true; option.parentElement.dispatchEvent(new Event('change', {bubbles: true})); }
      else { option.checked = true; option.dispatchEvent(new Event('change', {bubbles: true})); }
    }
    if (confirmed(option)) { stopPending(); sync(); }
    rendering = false;
  };
  const choose = (name, image) => {
    stopPending(); pending = {name, image};
    list.hidden = true; input.value = name;
    note.textContent = text('selecting', {name}); note.hidden = false;
    pendingTimer = setTimeout(() => { stopPending(); note.textContent = text('choose_manually', {name}); }, 12000);
    applyPending();
  };
  let searchTimer;
  input.addEventListener('input', () => {
    stopPending(); clearTimeout(searchTimer);
    searchTimer = setTimeout(() => {
      const query = searchNorm(input.value);
      list.replaceChildren(); note.hidden = true;
      if (query.length < 2) { list.hidden = true; return; }
      const hits = items.filter(item => searchNorm(item.name).includes(query)).slice(0, 40);
      hits.forEach(item => {
        const row = document.createElement('li'); const button = document.createElement('button'); button.type = 'button';
        const image = document.createElement('img'); image.src = item.image; image.alt = ''; image.loading = 'lazy';
        const label = document.createElement('span'); label.textContent = item.name;
        button.append(image, label); button.addEventListener('click', () => choose(item.name, item.image)); row.append(button); list.append(row);
      });
      list.hidden = !hits.length;
      if (!hits.length) { note.textContent = text('no_product_match'); note.append(' ', makeLink(galleryURL('', input.value.trim()), text('browse_all'))); note.hidden = false; }
    }, 120);
  });
  main.addEventListener('click', event => { if (event.isTrusted && event.target.closest('.gpo-element')) stopPending(); }, true);
  main.addEventListener('change', event => {
    if (event.target.closest('.gpo-element')) { if (event.isTrusted) stopPending(); requestAnimationFrame(sync); }
  });
  const observer = new MutationObserver(() => { applyPending(); sync(); });
  observer.observe(main, {childList: true, subtree: true});
  const loadingPoll = setInterval(() => { applyPending(); sync(); }, 200);
  setTimeout(() => clearInterval(loadingPoll), 15000);
  window.addEventListener('pagehide', () => { observer.disconnect(); clearInterval(loadingPoll); stopPending(); });
  const requestedName = params.get('mascot');
  if (requestedName) choose(requestedName, params.get('mascot_image'));
  else sync();
  const atc = main.querySelector('form[action*="/cart/add"]');
  if (atc) {
    let lastAttempt = 0;
    const attempt = () => {
      const option = selected();
      if (!option || !confirmed(option) || Date.now() - lastAttempt < 1000) return;
      lastAttempt = Date.now();
      emit('add_to_cart_clicked', {collection_key: collection, mascot: option.value, product_id: finder.dataset.productId, variant_id: atc.querySelector('[name="id"]')?.value});
    };
    atc.addEventListener('submit', attempt);
    main.addEventListener('click', event => { if (event.target.closest('[name="add"], [data-product-add], .gpo-clone-atc-button')) attempt(); }, true);
  }
})();
